import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-items-model',
  templateUrl: './add-items-model.component.html',
  styleUrls: ['./add-items-model.component.scss']
})
export class AddItemsModelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
